// Import the accessToken properly from the helper.util file
import { accessToken } from "@/services/utils/helper.util";
import { i18nLocale } from "@/services/utils/helper.util";

// "x-app": "3", // "WEB_APP_BACKOFFICE",
// "x-device": "3", // "WEB",

// Define loginHeader
export const requestLoginHeader: { [key: string]: object } = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "accept-language": i18nLocale.value === "en" ? "en:en" : "km:km",
    "x-app": "3",
    "x-device": "3",
    "x-device-name": "My Phone",
    "x-model-name": "iPhone X",
    "x-udid": "1a2b3c4d5e6f7g8h9i0",
    "x-os-version": "15.1",
    "x-app-version": "1.0.1",
    "x-app-build-version": "64",
  },
};

// Define headers with Authorization header containing the access token
export async function requestHeaders(): Promise<{ [key: string]: string }> {
  const token = await accessToken;

  return {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${token?.value}`,
    "accept-language": i18nLocale.value === "en" ? "en:en" : "km:km",
    "x-app": "3",
    "x-device": "3",
    "x-device-name": "My Phone",
    "x-model-name": "iPhone X",
    "x-udid": "1a2b3c4d5e6f7g8h9i0",
    "x-os-version": "15.1",
    "x-app-version": "1.0.1",
    "x-app-build-version": "64",
  };
}
